module.exports = __webpack_public_path__ + "static/img/shezhi.0d2120a9.png";